import { utils } from 'pixi.js';
import { EthereumClient, w3mConnectors, w3mProvider } from '@web3modal/ethereum';
import { Web3Modal } from '@web3modal/html';
import { configureChains, createConfig, mainnet } from '@wagmi/core';
import { createWalletClient, custom } from 'viem';

export const WALLET_MANAGER_EVENTS = {
    CONNECT : 'ACCOUNT_CONNECTED',
    DISCONNECT : 'ACCOUNT_DISCONNECTED',
};

class WalletManager {
    constructor() {
        this.event = new utils.EventEmitter();
    }

    newConnector()
    {
        const chains = [mainnet];
        const projectId = 'e7cdb4796d6867bd684abb78da4e0870';
        const { publicClient } = configureChains(chains, [w3mProvider({ projectId })]);
        const wagmiConfig = createConfig({
            autoConnect: true,
            connectors: w3mConnectors({ projectId, version: 1, chains }),
            publicClient,
        });
        this.ethereumClient = new EthereumClient(wagmiConfig, chains);
        this.web3modal = new Web3Modal({ projectId }, this.ethereumClient);
        this.web3modal.setDefaultChain(mainnet);
        this.web3modal.subscribeEvents(event => {
            if(event.name == WALLET_MANAGER_EVENTS.CONNECT){
                this.event.emit(WALLET_MANAGER_EVENTS.CONNECT);
            }else if(event.name == WALLET_MANAGER_EVENTS.DISCONNECT){
                this.event.emit(WALLET_MANAGER_EVENTS.DISCONNECT);
            }
        });
    }

    async Connect()
    {
        if(!this.web3modal) this.newConnector();
        await this.web3modal.openModal({root:'SelectNetwork'});
    }

    async Disconnect()
    {
        if(!this.ethereumClient) return;
        if(!this.ethereumClient.getAccount().isConnected) return;
        await this.ethereumClient.disconnect();
        this.web3modal.closeModal();
    }

    async SignMessage(message)
    {
        if(!this.Connected) return '';
        const account = this.ethereumClient.getAccount();
        const WalletClient = createWalletClient({
            account:account.address,
            chain:mainnet,
            transport: custom(await account.connector.getProvider()),
        });
        const signature = await WalletClient.signMessage({
            message,
        });
        return signature;
    }

    get Connected() {
        if(!this.ethereumClient) return false;
        return this.ethereumClient.getAccount().isConnected;
    }

    get WalletAddress() {
        if(!this.ethereumClient) return '';
        if (!this.ethereumClient.getAccount().isConnected) return '';
        return this.ethereumClient.getAccount().address;
    }
}

export const walletManager = new WalletManager();
